import { Component } from '@angular/core';
import { EmployeeConfirmationService } from '../../../Model/EmployeeConfirmation/employee-confirmation.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { ApprovalMatrixService } from '../../../Model/ApprovalMatrix/approval-matrix.service';
import { ComboService } from '../../../Model/Combo/combo.service';
import { CommonService } from '../../../Model/Common/common.service';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { ApprovalMatrixFormFilterComponent } from '../../ApprovalMatrixFormFilter/approval-matrix-form-filter/approval-matrix-form-filter.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@Component({
  selector: 'app-employee-confirmation-policies-form',
  standalone: true,
  imports: [CommonModule, FormsModule, NgSelectModule, NgbTooltip,],
  templateUrl: './employee-confirmation-policies-form.component.html',
  styleUrl: './employee-confirmation-policies-form.component.scss'
})
export class EmployeeConfirmationPoliciesFormComponent {
  isDisabled: boolean = false;
  user = [] as any;
  Applicabilitys = [] as any;
  ApplicabilityDatas = [] as any;
  ApplicabilityDatasFilter = [] as any;
  ExpenseCategorys = [] as any;
  Vehicles = [] as any;
  LastWebESSApplicabilityId = null;

  EmployeeConfirmation = {
    SelectType: 'insert',
    ESS_ConfirmationRuleID: 0,
    RuleName: null,
    PolicyBasedOnMonthOrDays: 'Months',
    ProbationPeriod: null,
    ProbationExtensionPeriod: null,
    NoOfTimesExtensionAllowed: null,
    DefaultRule: false,
    EmpType: 'FRONT',
    WebESSApplicabilityId: null as any,
    MappedId: null as any,
    IsManualAllowDate: false,
    AllowConfirmationBeforeDueDate: false,
  }

  Filter = {
    BranchID: null,
    ClientID: null,
    SiteID: null,
  }

  States = [] as any;
  StatesFilter = [] as any;
  Branchs = [] as any;
  BranchsFilter = [] as any;
  Clients = [] as any;
  ClientsFilter = [] as any;
  Sites = [] as any;
  SitesFilter = [] as any;
  Designations = [] as any;
  DesignationsFilter = [] as any;
  Companys = [] as any;
  CompanysFilter = [] as any;
  Departments = [] as any;
  DepartmentsFilter = [] as any;
  Users = [] as any;
  UsersFilter = [] as any;
  ApprovalSubCategory = [] as any;
  ApprovalSubCategoryFilter = [] as any;
  Grades = [] as any;
  GradesFilter = [] as any;

  constructor(
    private session: SessionService,
    private route: ActivatedRoute,
    private toast: ToastService,
    private router: Router,
    protected common: CommonService,
    protected tooltip: TooltipService,
    private approvalMatrix: ApprovalMatrixService,
    private combo: ComboService,
    private employeeconfirmation: EmployeeConfirmationService,
    private modalService: NgbModal,
    private dateFormat: CustomDateParserFormatter,
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    this.route.params.subscribe(params => this.EmployeeConfirmation.ESS_ConfirmationRuleID = parseInt(params['id']));
  }

  ngOnInit(): void {
    if (this.EmployeeConfirmation.ESS_ConfirmationRuleID > 0) {
      this.ESS_ConfirmationRuleLoad();
    } else {
      this.GetApplicability();
    }
  }

  Validate(form: any) {
    if (form.valid) {
      this.ESS_ConfirmationRule_InsertUpdate();
    }
    else {
      form.submitted = true;
    }
  }

  GetApplicability(IsClear = true) {
    this.isDisabled = true;
    this.approvalMatrix.GetApplicability({ SelectType: 'SR', WebESSApplicabilityMasterID: 0, EmpType: this.EmployeeConfirmation.EmpType }).subscribe({
      next: (response) => {
        this.Applicabilitys = response.Table;
        if (this.Applicabilitys.filter((e: any) => e.WebESSApplicabilityMasterID == this.EmployeeConfirmation.WebESSApplicabilityId).length == 0) {
          this.EmployeeConfirmation.WebESSApplicabilityId = null;
          this.ApplicabilityDatasFilter = [];
        } else if (this.EmployeeConfirmation.WebESSApplicabilityId == 8 && IsClear) {
          this.ApplicabilityDatasFilter = [];
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async ApplicabilityDataFilter(IsFilter = false) {
    // if (this.AttendanceRuleDetail.WebESSApplicabilityId != 8 || !IsFilter) {
    //   this.ApplicabilityDatas = [];
    //   this.ApplicabilityDatasFilter = [];
    // }
    if (IsFilter || await this.Confirmation(IsFilter)) {
      if (!IsFilter) {
        this.ApplicabilityDatas = [];
        this.ApplicabilityDatasFilter = [];
        this.EmployeeConfirmation.MappedId = null;
        this.LastWebESSApplicabilityId = this.EmployeeConfirmation.WebESSApplicabilityId;
      } else {
        this.ApplicabilityDatas = this.ApplicabilityDatasFilter.filter((e: any) => e.IsCheck);
        this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
      }

      this.Filter.BranchID = null;
      this.Filter.ClientID = null;
      this.Filter.SiteID = null;
      if (this.EmployeeConfirmation.WebESSApplicabilityId == 1) {
        this.ApprovalComboLoad('Company');
      } else if (this.EmployeeConfirmation.WebESSApplicabilityId == 2) {
        this.ApprovalComboLoad('Branch');
      } else if (this.EmployeeConfirmation.WebESSApplicabilityId == 5) {
        this.ApprovalComboLoad('Department');
      } else if (this.EmployeeConfirmation.WebESSApplicabilityId == 6) {
        this.ApprovalComboLoad('Designation');
      } else if (this.EmployeeConfirmation.WebESSApplicabilityId == 7) {
        this.ApprovalComboLoad('User');
      } else if (this.EmployeeConfirmation.WebESSApplicabilityId == 9) {
        this.ApprovalComboLoad('Grade');
      } else {
        if (this.EmployeeConfirmation.WebESSApplicabilityId != 0) {
          this.FilterForm();
        }
      }
    }
  }

  async Confirmation(IsFilter = false): Promise<boolean> {
    if (!IsFilter && this.LastWebESSApplicabilityId != null) {
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = this.tooltip.Message.ApplicabiliyChangeMessgae;
      modalRef.componentInstance.Message2 = this.tooltip.Message.ApplicabiliyChangeMessgae2;
      return modalRef.result.then((result) => {
        if (!result) {
          this.EmployeeConfirmation.WebESSApplicabilityId = this.LastWebESSApplicabilityId;
        }
        return result;
      });
    } else {
      return true;
    }
  }

  ButtonApplicabilityDataFilter(id = 0) {
    if (
      (id == 3 || id == 4 || id == 8) ||
      (id == 0 && (this.EmployeeConfirmation.WebESSApplicabilityId == 3 || this.EmployeeConfirmation.WebESSApplicabilityId == 4 || this.EmployeeConfirmation.WebESSApplicabilityId == 8))) {
      this.ApplicabilityDataFilter(true);
    } else {
      this.toast.show({ message: "Filter only allow for client & site", type: toastTypeEnum.warning });
    }
  }

  ApprovalComboLoad(Combotype: String, Combotype2 = null as any, index = 0) {
    this.isDisabled = true;
    this.combo.ApprovalComboLoad({
      'SelectType': Combotype,
      'BranchId': this.Filter.BranchID,
      'ClientId': this.Filter.ClientID,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Company') {
          this.Companys = response.Table.filter((e: any) => e.CompanyMasterId == parseInt(this.session.GetUserDetails().CompanyMasterId));
          this.CompanysFilter = response.Table.filter((e: any) => e.CompanyMasterId == parseInt(this.session.GetUserDetails().CompanyMasterId));

          this.Companys.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.CompanyMasterId,
                ApplicabilityData: element.CompanyName,
                WebESSApplicabilityId: this.EmployeeConfirmation.WebESSApplicabilityId,
                IsCheck: this.EmployeeConfirmation.MappedId != null ? this.EmployeeConfirmation.MappedId.split(',').findIndex((e: any) => e == element.CompanyMasterId) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Branch') {
          this.Branchs = response.Table;
          this.BranchsFilter = response.Table;

          this.Branchs.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.BranchMasterID,
                ApplicabilityData: element.BranchName,
                WebESSApplicabilityId: this.EmployeeConfirmation.WebESSApplicabilityId,
                IsCheck: this.EmployeeConfirmation.MappedId != null ? this.EmployeeConfirmation.MappedId.split(',').findIndex((e: any) => e == element.BranchMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Department') {
          this.Departments = response.Table;
          this.DepartmentsFilter = response.Table;

          this.Departments.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.DepartmentMasterID,
                ApplicabilityData: element.DepartmentName,
                WebESSApplicabilityId: this.EmployeeConfirmation.WebESSApplicabilityId,
                IsCheck: this.EmployeeConfirmation.MappedId != null ? this.EmployeeConfirmation.MappedId.split(',').findIndex((e: any) => e == element.DepartmentMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Designation') {
          this.Designations = response.Table;
          this.DesignationsFilter = response.Table;

          this.Designations.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.DesignationMasterID,
                ApplicabilityData: element.DesignationName,
                WebESSApplicabilityId: this.EmployeeConfirmation.WebESSApplicabilityId,
                IsCheck: this.EmployeeConfirmation.MappedId != null ? this.EmployeeConfirmation.MappedId.split(',').findIndex((e: any) => e == element.DesignationMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Client') {
          this.Clients = response.Table;
          this.ClientsFilter = response.Table;

          this.Clients.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.ClientGroupMasterID,
                ApplicabilityData: element.ClientGroupName,
                WebESSApplicabilityId: this.EmployeeConfirmation.WebESSApplicabilityId,
                IsCheck: this.EmployeeConfirmation.MappedId != null ? this.EmployeeConfirmation.MappedId.split(',').findIndex((e: any) => e == element.ClientGroupMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Site') {
          this.Sites = response.Table;
          this.SitesFilter = response.Table;

          this.Sites.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.SiteMasterID,
                ApplicabilityData: element.SiteName,
                WebESSApplicabilityId: this.EmployeeConfirmation.WebESSApplicabilityId,
                IsCheck: this.EmployeeConfirmation.MappedId != null ? this.EmployeeConfirmation.MappedId.split(',').findIndex((e: any) => e == element.SiteMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Designation') {
          this.Designations = response.ComboLoad;
          this.DesignationsFilter = response.ComboLoad;

          this.Designations.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.BranchMasterID,
                ApplicabilityData: element.BranchName,
                WebESSApplicabilityId: this.EmployeeConfirmation.WebESSApplicabilityId,
                IsCheck: this.EmployeeConfirmation.MappedId != null ? this.EmployeeConfirmation.MappedId.split(',').findIndex((e: any) => e == element.BranchMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'User' && Combotype2 == null) {
          this.Users = response.Table;
          this.UsersFilter = response.Table;

          this.Users.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.UserMasterId,
                ApplicabilityData: element.UserName,
                WebESSApplicabilityId: this.EmployeeConfirmation.WebESSApplicabilityId,
                IsCheck: this.EmployeeConfirmation.MappedId != null ? this.EmployeeConfirmation.MappedId.split(',').findIndex((e: any) => e == element.UserMasterId) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'User' && Combotype2 == 'Employee') {
          response.Table.forEach((element: any) => {
            this.ApprovalSubCategory.push(
              {
                ApprovalSubCategoryID: element.UserMasterId,
                ApprovalSubCategory: element.UserName,
              }
            );
          });
          this.ApprovalSubCategoryFilter[index] = this.ApprovalSubCategory;
        } else if (Combotype == 'Grade') {
          this.Grades = response.Table;
          this.GradesFilter = response.Table;

          this.Grades.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.GradeMasterId,
                ApplicabilityData: element.GradeName,
                WebESSApplicabilityId: this.EmployeeConfirmation.WebESSApplicabilityId,
                IsCheck: this.EmployeeConfirmation.MappedId != null ? this.EmployeeConfirmation.MappedId.split(',').findIndex((e: any) => e == element.GradeMasterId) >= 0 ? true : false : false,
              }
            );
          });
        } 
        this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        this.EmployeeConfirmation.MappedId = null;
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  FilterForm() {
    const modalRef = this.modalService.open(ApprovalMatrixFormFilterComponent);
    modalRef.componentInstance.Title = this.EmployeeConfirmation.WebESSApplicabilityId == 3 ? 'Client' : this.EmployeeConfirmation.WebESSApplicabilityId == 4 ? 'Site' : this.EmployeeConfirmation.WebESSApplicabilityId == 8 ? 'Employee' : '';
    modalRef.componentInstance.WebESSApplicabilityId = this.EmployeeConfirmation.WebESSApplicabilityId;
    modalRef.componentInstance.EmpType = this.EmployeeConfirmation.EmpType;
    modalRef.componentInstance.ShowFilter = {
      ShowBranch: (this.EmployeeConfirmation.WebESSApplicabilityId == 3 || this.EmployeeConfirmation.WebESSApplicabilityId == 4 || this.EmployeeConfirmation.WebESSApplicabilityId == 6) ? true : false,
      ShowClient: (this.EmployeeConfirmation.WebESSApplicabilityId == 4 || this.EmployeeConfirmation.WebESSApplicabilityId == 6) ? true : false,
      ShowSite: (this.EmployeeConfirmation.WebESSApplicabilityId == 6) ? true : false,
      ShowSearchEmployee: (this.EmployeeConfirmation.WebESSApplicabilityId == 8) ? true : false
    }
    modalRef.result.then(result => {
      this.Filter.BranchID = result.BranchID;
      this.Filter.ClientID = result.ClientID;
      this.Filter.SiteID = result.SiteID;
      if (this.EmployeeConfirmation.WebESSApplicabilityId == 1) {
        //this.ApprovalComboLoad('Company');
      } else if (this.EmployeeConfirmation.WebESSApplicabilityId == 2) {
        this.ApprovalComboLoad('Branch');
      } else if (this.EmployeeConfirmation.WebESSApplicabilityId == 3) {
        this.ApprovalComboLoad('Client');
      } else if (this.EmployeeConfirmation.WebESSApplicabilityId == 4) {
        this.ApprovalComboLoad('Site');
      } else if (this.EmployeeConfirmation.WebESSApplicabilityId == 5) {
        //this.ComboLoad('Department');
      } else if (this.EmployeeConfirmation.WebESSApplicabilityId == 6) {
        //this.ComboLoad('Designation');
      } else if (this.EmployeeConfirmation.WebESSApplicabilityId == 7) {
        //this.ComboLoad('User');
      } else if (this.EmployeeConfirmation.WebESSApplicabilityId == 8) {
        if (result != undefined) {
          result.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.EmpMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.EmpMasterID,
                  ApplicabilityData: element.FullName,
                  WebESSApplicabilityId: this.EmployeeConfirmation.WebESSApplicabilityId,
                  IsCheck: true
                }
              );
            }
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        }
      }
    });
  }

  ApplicabilityCheckAll(event: any) {
    this.ApplicabilityDatasFilter.map((e: any) => e.IsCheck = event.target.checked);
  }

  SearchDropdown(SearchValue: string, Label: string) {
    if (Label == 'Applicability') {
      this.ApplicabilityDatasFilter = this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityData.toLowerCase().includes(SearchValue.toLowerCase()));
    }
  }

  OrderByApplicability() {
    return this.ApplicabilityDatasFilter.sort((a: any, b: any) => a.ApplicabilityData.localeCompare(b.ApplicabilityData));
  }

  ComboLoad(Combotype: String, id: number) {
    this.isDisabled = true;
    this.combo.ComboLoad({ 'Combotype': Combotype, 'EmpMasterID': id, 'EmpType': this.EmployeeConfirmation.EmpType, }).subscribe({
      next: (response) => {
        if (Combotype == 'EmpLoadOnId') {
          if (response.ComboLoad.length > 0) {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == response.ComboLoad[0].EmpMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: response.ComboLoad[0].EmpMasterID,
                  ApplicabilityData: response.ComboLoad[0].FullName,
                  WebESSApplicabilityId: this.EmployeeConfirmation.WebESSApplicabilityId,
                  IsCheck: true
                }
              );
            }
          }

        }
        this.isDisabled = false;
      },
      complete: () => {

      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_ConfirmationRuleLoad() {
    this.isDisabled = true;
    this.employeeconfirmation.ESS_ConfirmationRuleLoad({ SelectType: 1, ESS_ConfirmationRuleID: this.EmployeeConfirmation.ESS_ConfirmationRuleID }).subscribe({
      next: (response) => {
        if (response.Table[0].EmpType == null || response.Table[0].EmpType == '') {
          response.Table[0].EmpType = 'FRONT';
        } else {
          response.Table[0].EmpType = response.Table[0].EmpType.toUpperCase();
        }
        this.EmployeeConfirmation = response.Table[0];
        this.EmployeeConfirmation.MappedId = response.Table2.map((e: any) => e.MappedId).toString();
        this.EmployeeConfirmation.SelectType = 'update';
        this.LastWebESSApplicabilityId = this.EmployeeConfirmation.WebESSApplicabilityId;
        if (this.EmployeeConfirmation.WebESSApplicabilityId == 1) {
          this.ApprovalComboLoad('Company');
        } else if (this.EmployeeConfirmation.WebESSApplicabilityId == 2) {
          this.ApprovalComboLoad('Branch');
        } else if (this.EmployeeConfirmation.WebESSApplicabilityId == 3) {
          //this.ApprovalComboLoad('Client');
          response.Table2.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.MappedId,
                ApplicabilityData: element.MappedValue,
                WebESSApplicabilityId: this.EmployeeConfirmation.WebESSApplicabilityId,
                IsCheck: true
              }
            );
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        } else if (this.EmployeeConfirmation.WebESSApplicabilityId == 4) {
          //this.ApprovalComboLoad('Site');
          response.Table2.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.MappedId,
                ApplicabilityData: element.MappedValue,
                WebESSApplicabilityId: this.EmployeeConfirmation.WebESSApplicabilityId,
                IsCheck: true
              }
            );
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        } else if (this.EmployeeConfirmation.WebESSApplicabilityId == 5) {
          this.ApprovalComboLoad('Department');
        } else if (this.EmployeeConfirmation.WebESSApplicabilityId == 6) {
          this.ApprovalComboLoad('Designation');
        } else if (this.EmployeeConfirmation.WebESSApplicabilityId == 7) {
          this.ApprovalComboLoad('User');
        } else if (this.EmployeeConfirmation.WebESSApplicabilityId == 8) {
          response.Table2.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.MappedId,
                ApplicabilityData: element.MappedValue,
                WebESSApplicabilityId: this.EmployeeConfirmation.WebESSApplicabilityId,
                IsCheck: true
              }
            );
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        } else if (this.EmployeeConfirmation.WebESSApplicabilityId == 9) {
          this.ApprovalComboLoad('Grade');
        } 
        if (this.EmployeeConfirmation.WebESSApplicabilityId == 8) {
          this.GetApplicability(false);
        } else {
          this.GetApplicability();
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async ESS_ConfirmationRule_InsertUpdate() {
    //await this.common.getPageRights();
    this.SearchDropdown('', 'Applicability');
    if (this.EmployeeConfirmation.EmpType != 'FRONT' && this.EmployeeConfirmation.EmpType != 'BACK') {
      this.toast.show({ message: 'Please select applicable for', type: toastTypeEnum.warning });
    } else if (this.EmployeeConfirmation.WebESSApplicabilityId == null) {
      this.toast.show({ message: "Please select applicability", type: toastTypeEnum.warning });
    } else if (this.EmployeeConfirmation.WebESSApplicabilityId > 0 && this.ApplicabilityDatasFilter.filter((e: any) => e.IsCheck).length == 0) {
      this.toast.show({ message: "Please select sub applicability", type: toastTypeEnum.warning });
    } else if (this.EmployeeConfirmation.WebESSApplicabilityId == 0 && this.EmployeeConfirmation.DefaultRule) {
      this.toast.show({ message: "Applicability none not allow for default rule yes", type: toastTypeEnum.warning });
    } else {
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = 'Do you want to save?';
      modalRef.result.then(result => {
        if ((this.common.PageRight.IsAdd && this.EmployeeConfirmation.ESS_ConfirmationRuleID == 0) || (this.common.PageRight.IsEdit && this.EmployeeConfirmation.ESS_ConfirmationRuleID > 0)) {
          if (result) {
            this.isDisabled = true;

            this.EmployeeConfirmation.MappedId = this.ApplicabilityDatasFilter.filter((e: any) => e.IsCheck && e.WebESSApplicabilityId == this.EmployeeConfirmation.WebESSApplicabilityId).map((e: any) => e.ApplicabilityDataID).toString();
            this.employeeconfirmation.ESS_ConfirmationRule_InsertUpdate(this.EmployeeConfirmation).subscribe({
              next: (response) => {
                if (response.Error_Code == "01") {
                  this.close();
                  this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
                } else {
                  this.toast.show({ message: response.Error_Message, type: toastTypeEnum.danger });
                }
                this.isDisabled = false;
              },
              complete: () => { },
              error: (error) => {
                this.isDisabled = false;
              },
            });
          }
        } else {
          this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
        }
      });
    }
  }

  close() {
    this.router.navigate(['/setting/employeeconfirmationpolicies/']);
  }
}
